<template>
  <div class="home">
    <!-- <main-title :arrowClick="false">
      <template v-slot:rightBtn>
        <img src="~images/video/icon-fh.png" class="imggs" />
      </template>
    </main-title> -->
    <!-- <map-nav-bar :btmList="btmList" class="w14" /> -->
    <div class="nav">
      <schj-nav></schj-nav>
    </div>
    <el-container class="main">
      <el-main>
        <div class="content">
          <component :is="component" />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import Vue from "vue";
// import schjCL from "./schjCL";
// import schjJG from "./schjJG";
// import schjXS from "./schjXS";
import { mapGetters } from "vuex";
const schjHQ = () => import("./schjHQ");
const schjLX = () => import("./schjLX");
const zbP = () => import("./zb");
const sdcg = () => import("./sdcg");
// import schjHQ from "./schjHQ";
// import schjLX from "./schjLX";
import schjNav from "./schjNav";
// const schjNav = Vue.component("schjNav", () => import("./schjNav.vue"));
export default {
  name: "schj",
  components: {
    // schjCL,
    // schjJG,
    // schjXS,
    schjHQ,
    schjLX,
    zbP,
    sdcg,
    schjNav
  },
  computed: {
    ...mapGetters(["fromPath"]),
    curcode() {
      return this.$store.state.schj.code;
    }
  },
  watch: {
    curcode: {
      handler(val) {
        switch (val) {
          case "cg":
            this.component = "sdcg";
            break;
          case "zb":
            this.component = "zbP";
            break;
          case "lt":
            this.component = "schjHQ";
            break;
          case "lx":
            this.component = "schjLX";
            break;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      component: "zbP"
      //   btmList: [
      //     {
      //       name: "1、华东地区（包括山东、江苏、安徽、浙江、福建、上海）：16.29%"
      //     },
      //     {
      //       name: "2、华南地区（包括广东、广西、海南）：31.54%"
      //     },
      //     {
      //       name: "3、华中地区（包括湖北、湖南、河南、江西）：8.08%"
      //     },
      //     {
      //       name: "4、华北地区（包括北京、天津、河北、山西、内蒙古）：7.57%"
      //     },
      //     {
      //       name: "5、西北地区（包括宁夏、新疆、青海、陕西、甘肃）：5.96%"
      //     },
      //     {
      //       name: "6、西南地区（包括四川、云南、贵州、西藏、重庆）：9.97%"
      //     },
      //     {
      //       name: "7、东北地区（包括辽宁、吉林、黑龙江）：5.85%"
      //     },
      //     {
      //       name: "8、台港澳地区（包括台湾、香港、澳门）：6.38%"
      //     }
      //   ]
    };
  },
  mounted() {
    window.setSchjTab = function(cur, cursel, n) {
      for (let i = 0; i < n; i++) {
        cur.parentNode
          .querySelector(".is-active")
          .classList.remove("is-active");
        cur.classList.add("is-active");
        var con = document.getElementById("pane1" + "-" + i);
        con.style.display = i == cursel ? "block" : "none";
      }
    };
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.imggs
    height 0.14rem
    position absolute
    bottom 0.01rem
    right 0.05rem
    cursor pointer
.home
    position fixed
    top 0
    left 0
    height 100%
    width 100%
    background url('~images/bg.png') no-repeat center
    background-size 100% 100%
    .nav
        z-index 9
        position absolute
        width 100%
        top 0
    .content
        position relative
        display flex
        height 100%
    .el-main
        position: absolute;
        left: 0;
        padding: 0;
        right: 0;
        top: 75px
        bottom: 0;
        overflow: hidden;
.w14
    width 16%
    line-height 1.5
    >>>.topNav
        color white
@media (max-width: 1366px)
    .home
        .nav
            top 68px
</style>
